export default {
  page: {
    title: 'Gerador de Texto',
    subtitle: 'Ferramentas',
  },
  card: {
    title: 'Configuração da geração',
  },
  form: {
    text: {
      label: 'Texto',
      placeholder: 'Digite o texto a ser gerado',
    },
    selected: {
      label: 'Selecionadas:',
    },
    enableSubWord: {
      label: 'Evitar palavra e subpalavra',
    },
  },
  button: {
    generate: 'Gerar',
    clear: 'Limpar',
    download: 'Baixar',
  },
  result: {
    list: {
      label: 'Lista:',
    },
    generatedText: {
      label: 'Texto gerado:',
      placeholder: 'O texto gerado aparecerá aqui',
    },
  },
  popover: {
    title: 'Palavras selecionadas',
    description: 'selecionadas',
  },
  alert: {
    repeatedWord: 'Palavra repetida! {word}',
  },
  help: {
    title: 'Instruções',
    steps: [
      'Digite ou cole o texto.',
      'Selecione uma palavra.',
      'Pressione Ctrl+B para marcá-la.',
      'Clique em Gerar.',
      'Faça o download.',
    ],
  },
};
